<template>
  <v-container fluid>
    <v-layout>
      <reply-message />
    </v-layout>
  </v-container>
</template>

<script>
import ReplyMessage from '@/components/ReplyMessage.vue';

export default {
  name: 'RSVP-Submit',
  components: {
    ReplyMessage,
  },
};

</script>

<style scoped></style>
